import React, { useEffect, useState } from 'react';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Modal, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { apiAction, generalSet } from '../../store/generalSlice';
import Spinner from '../../layout/Spinner';
import { parseJSON } from '../../utils/helpers';

const Actions = () => {
  const dispatch = useDispatch();
  const { actions, loadingActions } = useSelector((state) => state.general);
  const [open, setOpen] = useState(false);
  const [selectedAction, setSelectedAction] = useState(null);

  const [searchField, setSearchField] = useState('name');
  const [searchValue, setSearchValue] = useState('');

  const handleOpen = (action) => {
    setSelectedAction(action);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedAction(null);
  };

  const handleDelete = () => {
    dispatch(
      generalSet({
        reduxField: 'actions',
        value: actions.filter((act) => act._id !== selectedAction._id),
      })
    );
    dispatch(
      apiAction({
        reduxField: 'deletedAction',
        route: `actions/deleteActionById`,
        actionId: selectedAction._id,
      })
    );
    handleClose();
  };

  useEffect(() => {
    dispatch(apiAction({ reduxField: 'actions', route: 'actions/getActions', fields: ['actionType', 'actionData'] }));
  }, [dispatch]);

  console.log({ actions });
  return Array.isArray(actions) ? (
    <div className='p-4 mt-4' data-aos='fade-up' data-aos-delay='200'>
      <div className='row d-flex justify-content-center'>
        <div className='col-lg-12 d-flex justify-content-center border-bottom' data-aos='fade-up' data-aos-delay='200'>
          <h1>Actions</h1>
        </div>
      </div>
      <div className='row d-flex justify-content-center mt-4 pt-lg-0'>
        <Link to='/createAction' className='btn btn-outline-dark'>
          Create an Action
        </Link>
      </div>
      <div className='row d-flex justify-content-center mt-4'>
        <div className='col-md-6 d-flex justify-content-center'>
          <div className='btn-group'>
            <button className='btn btn-outline-secondary disabled border-0'>
              <i className='fas fa-search'></i>
            </button>
            <select value={searchField} onChange={(e) => setSearchField(e.target.value)} className='form-control'>
              <option value='name'>Name</option>
              <option value='_id'>ID</option>
              <option value='actionType'>Type</option>
            </select>
            <input type='text' className='form-control' onChange={(e) => setSearchValue(e.target.value)} />
          </div>
        </div>
      </div>

      {loadingActions ? (
        <Spinner />
      ) : (
        <div className='row d-flex justify-content-center mt-4 pt-lg-0'>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Action ID</TableCell>
                  <TableCell>Action Name</TableCell>
                  <TableCell>Action Type</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {actions.map((action) => {
                  const actionData = parseJSON(action.actionData);
                  if (searchField === 'name' && !actionData.name.toLowerCase().includes(searchValue.toLowerCase())) {
                    return null;
                  }
                  if (searchField === '_id' && !action._id.includes(searchValue)) {
                    return null;
                  }
                  if (
                    searchField === 'actionType' &&
                    !action.actionType.toLowerCase().includes(searchValue.toLowerCase())
                  ) {
                    return null;
                  }
                  return action?._id ? (
                    <TableRow key={action._id}>
                      <TableCell>{action._id}</TableCell>
                      <TableCell>{actionData.name}</TableCell>
                      <TableCell>{action.actionType}</TableCell>
                      <TableCell>
                        <Link className='btn btn-sm btn-outline-primary mr-2' to={`/action/${action._id}`}>
                          View
                        </Link>
                        <button className='btn btn-sm btn-outline-danger' onClick={() => handleOpen(action)}>
                          <i className='fa fa-trash' aria-hidden='true'></i>
                        </button>
                      </TableCell>
                    </TableRow>
                  ) : null;
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      )}
      <Modal
        open={open}
        onClose={handleClose}
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <div
          className='modal-content'
          style={{ padding: '20px', backgroundColor: 'white', borderRadius: '8px', outline: 'none', margin: '25%' }}
        >
          <h4>Confirm Deletion</h4>
          <p>Are you sure you want to delete this action?</p>
          <Button variant='contained' color='secondary' onClick={handleDelete}>
            Delete
          </Button>
          <Button variant='contained' onClick={handleClose}>
            Cancel
          </Button>
        </div>
      </Modal>
    </div>
  ) : (
    <Spinner />
  );
};

export default Actions;
